import { registerStyle } from '@wordpress/style-runtime';
if (typeof process === 'undefined' || process.env.NODE_ENV !== 'test') {
	registerStyle("20ed55e94a", "._502d8d4d00cc87a7__badge{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}");
}
export default {"badge":"_502d8d4d00cc87a7__badge"};
